/**
 * Module: `export/docx-list-levels.ts` — tighter bullet/number spacing for Word.
 */

import { AlignmentType, convertInchesToTwip, LevelFormat } from "docx";

/** Gap between bullet glyph and text (hanging indent), in inches. */
const HANGING_IN = 0.14;
/** First-level left indent (includes hanging). */
const BASE_LEFT_IN = 0.22;
/** Extra left indent per nesting level. */
const STEP_IN = 0.18;

function createLevelIndents(level: number) {
  return {
    left: convertInchesToTwip(BASE_LEFT_IN + level * STEP_IN),
    hanging: convertInchesToTwip(HANGING_IN),
  };
}

export function createTightBulletLevels() {
  return Array.from({ length: 9 }, (_, level) => ({
    level,
    format: LevelFormat.BULLET,
    text: "•",
    alignment: AlignmentType.LEFT,
    style: {
      paragraph: {
        indent: createLevelIndents(level),
      },
    },
  }));
}

export function createTightOrderedLevels() {
  return Array.from({ length: 9 }, (_, level) => ({
    level,
    format: LevelFormat.DECIMAL,
    text: `%${level + 1}.`,
    alignment: AlignmentType.LEFT,
    style: {
      paragraph: {
        indent: createLevelIndents(level),
      },
    },
  }));
}
